import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'
import { supabase } from '../lib/supabase'

export default function ReportingBooking() {
  const { bookingId } = useParams()
  const { profile, workshopId } = useAuth()
  const [row, setRow] = useState(null)
  const [error, setError] = useState('')
  const owner = profile?.role === 'owner' && profile.workshop_id === workshopId
  useEffect(() => {
    if (!owner) return undefined
    let cancelled = false
    setRow(null)
    setError('')
    supabase.from('booking_requests').select('id,status,customer_id,customer_name,service_summary,preferred_date,estimated_total,pricing_mode,converted_job_id')
      .eq('workshop_id', workshopId).eq('id', bookingId).maybeSingle().then(({ data, error }) => {
        if (!cancelled) { setRow(data); setError(error || !data ? 'Booking unavailable.' : '') }
      }).catch(() => { if (!cancelled) setError('Booking unavailable.') })
    return () => { cancelled = true }
  }, [owner, workshopId, bookingId])
  if (!owner) return <p role="alert">Reporting requires the workshop owner.</p>
  return <section><a href="/reporting">Back to reporting</a><h1>Booking record</h1>
    <p>Current source record. This is not the earlier report capture.</p>
    {error && <p role="alert">{error}</p>}
    {!row && !error && <p>Loading booking…</p>}
    {row && <dl>{Object.entries(row).map(([key, value]) => <React.Fragment key={key}>
      <dt>{key.replace(/_/g, ' ')}</dt><dd>{value == null || value === '' ? 'Unknown' : String(value)}</dd>
    </React.Fragment>)}</dl>}
    {row?.converted_job_id && <a href={`/jobs?job=${encodeURIComponent(row.converted_job_id)}`}>Open linked job</a>}
  </section>
}
